import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  TextField,
  Box,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ActionButtons from "../InitialKickoff/MaterialTopics/ActionButtons";
import { companyId } from "../../../utils/companyId";
import { api } from "../../../utils/api";
import { ProgressContext } from "../ContextAPI";
import {
  numberError,
  percentageError,
  twoFieldError,
} from "../../../utils/validationMessage";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import SkipQuestionare from "../../Common/SkipQuestionare";
import InitialQuestionareSidebar from "../../../Layout/InitialQuestionareSidebar";
import { getQuestionareSubmitted } from "../../../utils/storage";

const HumanRight = () => {
  const companyDetails = getQuestionareSubmitted();

  const { setUpdate } = useContext(ProgressContext);
  const navigate = useNavigate();
  const [numberOfAssessments, setNumberOfAssessments] = useState("");
  const [percentageOperationsAssessed, setPercentageOperationsAssessed] =
    useState("");
  const [policies, setPolicies] = useState([
    { existence: "", implementation: "" },
  ]);
  const [totalIncidents, setTotalIncidents] = useState("");
  const [percentageResolution, setPercentageResolution] = useState("");
  const [getData, setGetData] = useState(true);
  const [isExist, setIsExist] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [policyToDeleteIndex, setPolicyToDeleteIndex] = useState(null);
  const [errors, setErrors] = useState({
    numberOfAssessments: "",
    percentageOperationsAssessed: "",
    policies: [],
    implementation: [],
    totalIncidents: "",
    percentageResolution: "",
    humanRightsIncidentsReported: "",
    humanRightsIncidentsResolved: "",
    resolutionRate: "",
    supplyChainAssesments: "",
  });

  const [formData, setFormData] = useState({
    humanRightsIncidentsReported: "",
    humanRightsIncidentsResolved: "",
    resolutionRate: "",
    supplyChainAssesments: "",
  });

  useEffect(() => {
    setUpdate("SOCIAL");
    const fetchData = async () => {
      if (companyId) {
        try {
          const response = await axios.get(
            `${api}/social/human_rights/${companyId}`
          );
          const data = response.data;

          // Set state with fetched data
          setNumberOfAssessments(
            data.humanRightsAssessments.numberOfAssessmentsDone ?? ""
          );
          setPercentageOperationsAssessed(
            data.humanRightsAssessments.percentageOfOperationsAssessed.value ??
              ""
          );
          setPolicies(
            data.policiesAndProcedures || [
              { existence: "", implementation: "" },
            ]
          );
          setTotalIncidents(
            data.incidentsOfHumanRightsViolations.totalIncidentsRaised ?? ""
          );
          setPercentageResolution(
            data.incidentsOfHumanRightsViolations.percentageOfResolution
              .value ?? ""
          );
          setFormData({
            humanRightsIncidentsReported:
              data.humanRightsIncidentsReported ?? "",
            humanRightsIncidentsResolved:
              data.humanRightsIncidentsResolved ?? "",
            resolutionRate: data.resolutionRate ?? "",
            supplyChainAssesments: data.supplyChainAssesments ?? "",
          });
          setIsExist(true);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setGetData(false);
        }
      } else {
        setGetData(false);
      }
    };

    fetchData();
  }, []);

  const validateFields = () => {
    let isValid = true;
    const newErrors = {
      numberOfAssessments: "",
      percentageOperationsAssessed: "",
      policies: [],
      implementation: [],
      totalIncidents: "",
      percentageResolution: "",
      humanRightsIncidentsReported: "",
      humanRightsIncidentsResolved: "",
      resolutionRate: "",
      supplyChainAssesments: "",
    };

    // if (numberOfAssessments === "" || numberOfAssessments === null) {
    //   newErrors.numberOfAssessments = textError;
    //   isValid = false;
    // } else
    if (isNaN(numberOfAssessments) || numberOfAssessments < 0) {
      newErrors.numberOfAssessments = numberError;
      isValid = false;
    }

    // if (!percentageOperationsAssessed) {
    // if (
    //   percentageOperationsAssessed === "" ||
    //   percentageOperationsAssessed === null
    // ) {
    //   newErrors.percentageOperationsAssessed = textError;
    //   isValid = false;
    // } else
    if (
      isNaN(percentageOperationsAssessed) ||
      percentageOperationsAssessed < 0 ||
      percentageOperationsAssessed > 100
    ) {
      newErrors.percentageOperationsAssessed = percentageError;
      isValid = false;
    }

    policies.forEach((policy, index) => {
      if (index === 0) return;
      if (!policy.existence) {
        newErrors.policies[index] = twoFieldError;
        isValid = false;
      }
      if (!policy.implementation) {
        newErrors.implementation[index] = twoFieldError;
        isValid = false;
      }
    });

    // if (totalIncidents === "" || totalIncidents === null) {
    //   newErrors.totalIncidents = textError;
    //   isValid = false;
    // } else
    if (isNaN(totalIncidents) || totalIncidents < 0) {
      newErrors.totalIncidents = numberError;
      isValid = false;
    }

    // if (percentageResolution === "" || percentageResolution === null) {
    //   newErrors.percentageResolution = textError;
    //   isValid = false;
    // } else
    if (
      isNaN(percentageResolution) ||
      percentageResolution < 0 ||
      percentageResolution > 100
    ) {
      newErrors.percentageResolution = percentageError;
      isValid = false;
    }

    if (
      isNaN(formData.humanRightsIncidentsReported) ||
      formData.humanRightsIncidentsReported < 0
    )
      newErrors.humanRightsIncidentsReported = numberError;

    if (
      isNaN(formData.humanRightsIncidentsResolved) ||
      formData.humanRightsIncidentsResolved < 0
    )
      newErrors.humanRightsIncidentsResolved = numberError;

    if (isNaN(formData.resolutionRate) || formData.resolutionRate < 0)
      newErrors.resolutionRate = numberError;

    if (
      isNaN(formData.supplyChainAssesments) ||
      formData.supplyChainAssesments < 0
    )
      newErrors.supplyChainAssesments = numberError;

    setErrors(newErrors);
    return isValid;
  };

  const Save = async () => {
    if (!validateFields()) {
      return;
    }

    const humanRightsData = {
      humanRightsAssessments: {
        numberOfAssessmentsDone:
          numberOfAssessments !== "" ? Number(numberOfAssessments) : null,
        percentageOfOperationsAssessed: {
          value:
            percentageOperationsAssessed !== ""
              ? Number(percentageOperationsAssessed)
              : null,
          unit: "%",
        },
      },
      policiesAndProcedures: policies,
      incidentsOfHumanRightsViolations: {
        totalIncidentsRaised:
          totalIncidents !== "" ? Number(totalIncidents) : null,
        percentageOfResolution: {
          value:
            percentageResolution !== "" ? Number(percentageResolution) : null,
          unit: "%",
        },
      },
      humanRightsIncidentsReported: formData.humanRightsIncidentsReported,
      humanRightsIncidentsResolved: formData.humanRightsIncidentsResolved,
      resolutionRate: formData.resolutionRate,
      supplyChainAssesments: formData.supplyChainAssesments,
      companyId: companyId,
    };

    try {
      const hasValidValue = (val) =>
        val !== undefined && val !== null && val.toString().trim() !== "";

      const hasValidAssessments =
        !isNaN(
          humanRightsData.humanRightsAssessments.numberOfAssessmentsDone
        ) &&
        !isNaN(
          humanRightsData.humanRightsAssessments.percentageOfOperationsAssessed
            .value
        );

      const hasValidIncidents =
        !isNaN(
          humanRightsData.incidentsOfHumanRightsViolations.totalIncidentsRaised
        ) &&
        !isNaN(
          humanRightsData.incidentsOfHumanRightsViolations
            .percentageOfResolution.value
        );

      const hasValidPolicies =
        Array.isArray(policies) &&
        policies.length > 0 &&
        policies.every(
          (p) =>
            hasValidValue(p.existence?.toString().trim()) &&
            hasValidValue(p.implementation?.toString().trim())
        );

      humanRightsData.human_right =
        hasValidAssessments && hasValidIncidents && hasValidPolicies;
      if (isExist) {
        await axios.put(
          `${api}/social/human_rights/${companyId}`,
          humanRightsData
        );
        // alert('Human Rights record updated successfully.');
      } else {
        await axios.post(`${api}/social/human_rights`, humanRightsData);
        // alert('Human Rights record created successfully.');
      }
      navigate(
        companyDetails?.questionareSubmitted
          ? "/preview"
          : "/social/customer-relation"
      );
    } catch (error) {
      console.error("Error saving data:", error);
      // alert('An error occurred while saving data.');
    }
  };

  const Back = () => {
    navigate("/social/community");
  };

  const handleAddPolicy = () => {
    setPolicies([...policies, { existence: "", implementation: "" }]);
  };

  const handleDeletePolicy = (index) => {
    setPolicyToDeleteIndex(index);
    setOpenDialog(true);
  };

  const handleConfirmDelete = () => {
    const updatedPolicies = policies.filter(
      (_, i) => i !== policyToDeleteIndex
    );
    setPolicies(updatedPolicies);
    setErrors((prevErrors) => {
      const newPoliciesErrors = [...prevErrors.policies];
      newPoliciesErrors.splice(policyToDeleteIndex, 1);
      return { ...prevErrors, policies: newPoliciesErrors };
    });
    setOpenDialog(false);
    setPolicyToDeleteIndex(null); // Reset the index
  };

  const handleCancelDelete = () => {
    setOpenDialog(false);
    setPolicyToDeleteIndex(null); // Reset the index
  };

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const commonTextFieldProps = (
    field,
    label,
    unit,
    error,
    disabled = false
  ) => ({
    variant: "outlined",
    value: formData[field],
    disabled: disabled,
    onChange: (e) => {
      const value = e.target.value;
      if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
        handleChange(field)(e);
      }
    },
    onKeyDown: (e) => {
      if (
        !/[0-9.]/.test(e.key) &&
        !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(
          e.key
        )
      ) {
        e.preventDefault();
      }
    },
    sx: {
      mb: 1,
      width: "100%",
      backgroundColor: "#EDEDED",
      borderRadius: "8px",
      "& .MuiOutlinedInput-root": {
        "&.Mui-focused fieldset": {
          borderColor: error ? "#D34040" : "#1976d2",
        },
      },
      "& fieldset": {
        borderColor: error ? "#D34040" : "inherit",
      },
    },
    placeholder: "Please enter number",
    error: Boolean(error),
    helperText: error && (
      <span style={{ color: "#D34040", marginLeft: "-12px", fontSize: "14px" }}>
        {error}
      </span>
    ),
    InputProps: {
      endAdornment: unit ? (
        <InputAdornment position="end">
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                height: "44px",
                width: "1px",
                bgcolor: "#6b6c6d",
                marginRight: "8px",
              }}
            />
            {unit}
          </Box>
        </InputAdornment>
      ) : null,
    },
  });

  return (
    <Box>
      <Dialog open={openDialog} onClose={handleCancelDelete}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this policy?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Box
        sx={{ display: "flex", backgroundColor: "#EDEDED", height: "100vh" }}
      >
        <Box
          sx={{
            width: "25vw",
            // overflowY: "auto",
          }}
        >
          <InitialQuestionareSidebar />
        </Box>
        <Box
          sx={{
            p: 2,
            mt: 3,
            width: "75vw",
            height: "100vh", // Full viewport height
            overflowY: "auto", // Allow vertical scrolling if content exceeds viewport
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start", // Adjust to start at the top of the box
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "80%",
              marginBottom: "1rem",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                zIndex: 1,
                padding: "10px 0px",
                borderRadius: "4px",
                alignSelf: "flex-start",
              }}
            >
              SOCIAL: HUMAN RIGHTS
            </Typography>
            <SkipQuestionare />
          </div>

          <Box sx={{ width: "80%" }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                marginBottom: "2px",
                marginTop: "20px",
                width: "100%",
              }}
            >
              Human Rights Assessments
            </Typography>
            <Box display="flex" gap={2} mb={2} sx={{ width: "100%" }}>
              <TextField
                variant="outlined"
                placeholder="Number of assessments done"
                value={numberOfAssessments}
                onChange={(e) => {
                  setNumberOfAssessments(e.target.value);
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    numberOfAssessments: "",
                  }));
                }}
                sx={{
                  width: "100%",
                  backgroundColor: "#EDEDED",
                  borderRadius: "4px",
                  borderColor: errors.numberOfAssessments ? "red" : "#6b6c6d",
                  "& .MuiOutlinedInput-root": {
                    height: "50px",
                    "& fieldset": {
                      borderColor: errors.numberOfAssessments
                        ? "red"
                        : "#6b6c6d",
                    },
                  },
                }}
                InputProps={{ sx: { padding: "0 10px" } }}
                error={!!errors.numberOfAssessments}
                // helperText={errors.numberOfAssessments}
                helperText={
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "14px", marginLeft: "-10px" }}
                  >
                    {errors.numberOfAssessments}
                  </Typography>
                }
              />
              <TextField
                variant="outlined"
                placeholder="% of operations assessed"
                value={percentageOperationsAssessed}
                onChange={(e) => {
                  setPercentageOperationsAssessed(e.target.value);
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    percentageOperationsAssessed: "",
                  }));
                }}
                sx={{
                  width: "100%",
                  backgroundColor: "#EDEDED",
                  borderRadius: "4px",
                  borderColor: errors.percentageOperationsAssessed
                    ? "red"
                    : "#6b6c6d",
                  "& .MuiOutlinedInput-root": {
                    height: "50px",
                    "& fieldset": {
                      borderColor: errors.percentageOperationsAssessed
                        ? "red"
                        : "#6b6c6d",
                    },
                  },
                }}
                InputProps={{ sx: { padding: "0 10px" } }}
                error={!!errors.percentageOperationsAssessed}
                // helperText={errors.percentageOperationsAssessed}
                helperText={
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "14px", marginLeft: "-10px" }}
                  >
                    {errors.percentageOperationsAssessed}
                  </Typography>
                }
              />
            </Box>

            <Typography
              variant="subtitle1"
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                margin: "20px 0px 2px 0px",
                width: "80%",
              }}
            >
              Policies and Procedures on Human Rights
            </Typography>
            {policies.map((policy, index) => (
              <Box key={index} sx={{ width: "110%", display: "flex", gap: 1 }}>
                <Box
                  display="flex"
                  gap={2}
                  mb={2}
                  key={index}
                  sx={{ width: "91%" }}
                >
                  <TextField
                    variant="outlined"
                    placeholder="Existence"
                    multiline
                    value={policy.existence}
                    rows={3} // Adjust the number of rows as needed
                    onChange={(e) => {
                      const updatedPolicies = [...policies];
                      updatedPolicies[index].existence = e.target.value;
                      setPolicies(updatedPolicies);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        policies: {
                          ...prevErrors.policies,
                          [index]: "",
                        },
                      }));
                    }}
                    sx={{
                      width: "100%",
                      backgroundColor: "#EDEDED",
                      borderRadius: "4px",
                      borderColor: errors.policies[index]
                        ? "#D34040"
                        : "#6b6c6d",
                      "& .MuiOutlinedInput-root": {
                        height: "auto", // Set height to auto for multiline
                        "& fieldset": {
                          borderColor: errors.policies[index]
                            ? "#D34040"
                            : "#6b6c6d",
                        },
                      },
                      overflow: "hidden", // Prevent overflow
                      textOverflow: "ellipsis", // Handle overflow
                    }}
                    error={!!errors.policies[index]}
                    // helperText={errors.policies[index]}
                    helperText={
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "14px", marginLeft: "-10px" }}
                      >
                        {errors.policies[index]}
                      </Typography>
                    }
                  />

                  <TextField
                    variant="outlined"
                    placeholder="Implementation"
                    multiline
                    value={policy.implementation}
                    rows={3} // Adjust the number of rows as needed
                    onChange={(e) => {
                      const updatedPolicies = [...policies];
                      updatedPolicies[index].implementation = e.target.value;
                      setPolicies(updatedPolicies);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        implementation: {
                          ...prevErrors.implementation,
                          [index]: "",
                        },
                      }));
                    }}
                    sx={{
                      width: "100%",
                      backgroundColor: "#EDEDED",
                      borderRadius: "4px",
                      borderColor: errors.implementation[index]
                        ? "red"
                        : "#6b6c6d",
                      "& .MuiOutlinedInput-root": {
                        height: "auto", // Set height to auto for multiline
                        "& fieldset": {
                          borderColor: errors.implementation[index]
                            ? "red"
                            : "#6b6c6d",
                        },
                      },
                      overflow: "hidden", // Prevent overflow
                      textOverflow: "ellipsis", // Handle overflow
                    }}
                    error={!!errors.implementation[index]}
                    // helperText={errors.policies[index]}
                    helperText={
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "14px", marginLeft: "-10px" }}
                      >
                        {errors.implementation[index]}
                      </Typography>
                    }
                  />
                </Box>
                {index > 0 && (
                  <IconButton
                    onClick={() => handleDeletePolicy(index)}
                    sx={{ mt: 1 }}
                  >
                    <DeleteIcon />
                  </IconButton>
                )}
              </Box>
            ))}
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={handleAddPolicy}
                sx={{
                  alignSelf: "flex-end",
                  color: "#74757E",
                  borderColor: "#74757E",
                  display: "flex",
                  justifyContent: "flex-end",
                  "&:hover": {
                    backgroundColor: "rgba(25, 118, 210, 0.04)",
                    color: "#115293",
                    borderColor: "#115293",
                  },
                }}
                disabled={
                  !policies[0]?.existence?.trim() ||
                  !policies[0]?.implementation?.trim()
                }
              >
                Add
              </Button>
            </Box>

            <Typography
              variant="subtitle1"
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                margin: "20px 0px 2px 0px",
                width: "100%",
              }}
            >
              Incidents of Human Rights Violations
            </Typography>
            <Box display="flex" gap={2} mb={2} sx={{ width: "100%" }}>
              <TextField
                variant="outlined"
                placeholder="Total number of incidents raised"
                value={totalIncidents}
                onChange={(e) => {
                  setTotalIncidents(e.target.value);
                  setErrors({ ...errors, totalIncidents: "" });
                }}
                sx={{
                  width: "100%",
                  backgroundColor: "#EDEDED",
                  borderRadius: "4px",
                  borderColor: errors.totalIncidents ? "#D34040" : "#6b6c6d",
                  "& .MuiOutlinedInput-root": {
                    height: "50px",
                    "& fieldset": {
                      borderColor: errors.totalIncidents
                        ? "#D34040"
                        : "#6b6c6d",
                    },
                  },
                }}
                InputProps={{ sx: { padding: "0 10px" } }}
                error={!!errors.totalIncidents}
                // helperText={errors.totalIncidents}
                helperText={
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "14px", marginLeft: "-10px" }}
                  >
                    {errors.totalIncidents}
                  </Typography>
                }
              />
              <TextField
                variant="outlined"
                placeholder="% of resolution"
                value={percentageResolution}
                onChange={(e) => {
                  setPercentageResolution(e.target.value);
                  setErrors({ ...errors, percentageResolution: "" });
                }}
                sx={{
                  width: "100%",
                  backgroundColor: "#EDEDED",
                  borderRadius: "4px",
                  borderColor: errors.percentageResolution
                    ? "#D34040"
                    : "#6b6c6d",
                  "& .MuiOutlinedInput-root": {
                    height: "50px",
                    "& fieldset": {
                      borderColor: errors.percentageResolution
                        ? "#D34040"
                        : "#6b6c6d",
                    },
                  },
                }}
                InputProps={{ sx: { padding: "0 10px" } }}
                error={!!errors.percentageResolution}
                // helperText={errors.percentageResolution}
                helperText={
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "14px", marginLeft: "-10px" }}
                  >
                    {errors.percentageResolution}
                  </Typography>
                }
              />
            </Box>

            <Box sx={{ width: "100%" }}>
              {[
                {
                  field: "humanRightsIncidentsReported",
                  label:
                    "Number of human right incidents reported in this year",
                  error: errors.humanRightsIncidentsReported,
                },
                {
                  field: "humanRightsIncidentsResolved",
                  label:
                    "Number of human right incidents resolved in this year",
                  error: errors.humanRightsIncidentsResolved,
                },
                {
                  field: "resolutionRate",
                  label: "Resolution Rate (%)",
                  error: errors.resolutionRate,
                },
                {
                  field: "supplyChainAssesments",
                  label:
                    "Supply chain human rights assessment(% of suppliers accessed)",
                  error: errors.turnoverRate,
                },
              ].map(({ field, label, unit, error, disabled }) => (
                <Box key={field}>
                  <Typography
                    variant="body1"
                    sx={{ mb: 1, mt: 2, fontWeight: "bold" }}
                  >
                    {label}
                  </Typography>
                  <TextField
                    {...commonTextFieldProps(
                      field,
                      label,
                      unit,
                      error,
                      disabled
                    )}
                  />
                </Box>
              ))}
            </Box>

            <div style={{ width: "100%" }}>
              <ActionButtons
                Back={Back}
                Move={Save}
                disable={companyDetails?.questionareSubmitted}
              />
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HumanRight;
